import { createLogic } from "redux-logic";
import { getQuestions } from "../../../data/api";
import Constants from "../../../data/constants";
import { handleErrors } from "../../../data/helpers";
import { getCartId } from "../../../data/localStorageHelpers";
import { setQuestionsData, updateQuestionsStatus } from "../actions";
import { UPDATE_QUESTIONS_DATA } from "../types";
var updateQuestionsLogic = createLogic({
    type: UPDATE_QUESTIONS_DATA,
    latest: true,
    process: function (_a, dispatch, done) {
        var getState = _a.getState, action = _a.action;
        var _b = getState(), events = _b.events, cart = _b.cart, record = _b.record, app = _b.app;
        if (events === null || events === void 0 ? void 0 : events.event) {
            var _c = events.event, clientKey_1 = _c.clientKey, urlKey_1 = _c.urlKey, eventNumber_1 = _c.eventNumber, verbiage_1 = _c.verbiage, addOns_1 = _c.addOns;
            var updateCartAction_1 = action;
            dispatch(updateQuestionsStatus({ isLoading: true, timesLoaded: cart.questionsStatus.timesLoaded }));
            getQuestions(getCartId(events.event.eventNumber), events.event.eventNumber.toString())
                .then(function (_a) {
                var _b, _c, _d;
                var data = _a.data;
                if (data.length) {
                    if (data.every(function (a) {
                        var _a, _b, _c;
                        return a.canContinue &&
                            (((_a = record.questionSubmitHistory) === null || _a === void 0 ? void 0 : _a.submittedForms.includes(a.isAttendee ? a.id : (_c = (_b = cart.cart) === null || _b === void 0 ? void 0 : _b.cartId) !== null && _c !== void 0 ? _c : "")) ||
                                a.fields.length === 0 ||
                                (a.isPreRegistered && app.isAutoRegMode));
                    })) {
                        if (window.location.pathname !==
                            (app.isAutoRegMode
                                ? Constants.Routes.autoreg
                                : verbiage_1 === "Tickets"
                                    ? Constants.Routes.tickets
                                    : Constants.Routes.register)
                                .replace(":clientKey", clientKey_1)
                                .replace(":urlKey", urlKey_1)
                                .replace(":eventNumber", eventNumber_1.toString()) &&
                            window.location.pathname !==
                                Constants.Routes.details
                                    .replace(":clientKey", clientKey_1)
                                    .replace(":urlKey", urlKey_1)
                                    .replace(":eventNumber", eventNumber_1.toString()) &&
                            (window.location.pathname !==
                                Constants.Routes.addons
                                    .replace(":clientKey", clientKey_1)
                                    .replace(":urlKey", urlKey_1)
                                    .replace(":eventNumber", eventNumber_1.toString()) || (cart.cartStatus.isLoading === false && ((_c = (_b = cart.cart) === null || _b === void 0 ? void 0 : _b.attendees.length) !== null && _c !== void 0 ? _c : 0) === 0)) &&
                            window.location.pathname !==
                                Constants.Routes.cart
                                    .replace(":clientKey", clientKey_1)
                                    .replace(":urlKey", urlKey_1)
                                    .replace(":eventNumber", eventNumber_1.toString()) &&
                            window.location.pathname !==
                                Constants.Routes.checkout
                                    .replace(":clientKey", clientKey_1)
                                    .replace(":urlKey", urlKey_1)
                                    .replace(":eventNumber", eventNumber_1.toString()) &&
                            !["my", "assigned"].includes(((_d = window.location.pathname.split("/")[4]) !== null && _d !== void 0 ? _d : "").toLowerCase())) {
                            if ((events === null || events === void 0 ? void 0 : events.event) && (updateCartAction_1 === null || updateCartAction_1 === void 0 ? void 0 : updateCartAction_1.payload)) {
                                var isQuestions = window.location.pathname ===
                                    Constants.Routes.questions
                                        .replace(":clientKey", clientKey_1)
                                        .replace(":urlKey", urlKey_1)
                                        .replace(":eventNumber", eventNumber_1.toString())
                                        .replace(":attendeeId?", "");
                                var url = (isQuestions && addOns_1.some(function (a) { return a.isAvailable; }) ? Constants.Routes.addons : Constants.Routes.cart)
                                    .replace(":clientKey", clientKey_1)
                                    .replace(":urlKey", urlKey_1)
                                    .replace(":eventNumber", eventNumber_1.toString());
                                updateCartAction_1 === null || updateCartAction_1 === void 0 ? void 0 : updateCartAction_1.payload(url);
                            }
                        }
                    }
                }
                else {
                    if ((events === null || events === void 0 ? void 0 : events.event) && (updateCartAction_1 === null || updateCartAction_1 === void 0 ? void 0 : updateCartAction_1.payload)) {
                        var url = (verbiage_1 === "Tickets" ? Constants.Routes.tickets : Constants.Routes.register)
                            .replace(":clientKey", clientKey_1)
                            .replace(":urlKey", urlKey_1)
                            .replace(":eventNumber", eventNumber_1.toString());
                        updateCartAction_1.payload(url);
                    }
                }
                dispatch(setQuestionsData(data));
            })
                .catch(function (error) {
                dispatch(setQuestionsData(undefined));
                handleErrors(error, dispatch);
            })
                .finally(function () {
                dispatch(updateQuestionsStatus({ isLoading: false, timesLoaded: cart.questionsStatus.timesLoaded + 1 }));
                done();
            });
        }
        else {
            done();
        }
    },
});
var exportable = [updateQuestionsLogic];
export default exportable;
